// extracted by mini-css-extract-plugin
export default {"containerStyle":"RegistrationContainer__containerStyle___UxofW"};